var angular = require('angular')
angular.module('promemoria').component('auiLoader', {
  bindings: {
    active: '<'
  },
  template: require('./loader.html'),
  controller: function ($scope, $element, $attrs) {
    this.firstLoad = true
    this.$onChanges = function (changeObj) {
      if (!changeObj.active.previousValue && this.firstLoad) {
        this.firstLoad = false
      }
      if (!changeObj.active.currentValue) {
        this.show = false
        document.querySelector('body').style.overflow = 'auto'
      } else {
        this.show = true
        document.querySelector('body').style.overflow = 'auto'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/js/components/loader/loader.js